import {useEffect, useState} from 'react'
import {Link, useParams} from 'react-router-dom'
import axios from 'axios'

const APP_URL = process.env.REACT_APP_URL || 'http://localhost:3011'

export function VerifyDevice() {
  const [message, setMessage] = useState('')
  const [statusCode, setStatusCode] = useState<number>(0)
  useEffect(() => {
    let url_atual = window.location.href
    let sendVerify = url_atual.replace(`${APP_URL}/auth/verifydevice/`, '')

    axios
      .get(sendVerify)
      .then(function (response) {
        setMessage(response.data[0])
        setStatusCode(200)
      })
      .catch(function (error) {
        setMessage('Falha ao Verificar Dispositivo.')
        setStatusCode(404)
      })
      .finally(function () {
        // always executed
      })
  }, [])

  return (
    <>
      {statusCode === 200 && statusCode != undefined ? (
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h3 className='text-dark mb-3'>{message}</h3>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-400 fw-bold fs-5'>Bem vindo ao Sistema Orbitgeo.</div>
          {/* end::Link */}
          <div>
            {' '}
            <Link to={'/'} className='btn btn btn-sm btn-light-primary mt-5'>
              Voltar ao inicio
            </Link>
          </div>
        </div>
      ) : (
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h3 className='text-dark mb-3'>{message}</h3>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-400 fw-bold fs-5'>
            {statusCode === 404 ? 'Contate o nosso suporte suporte.' : 'Validando...'}
          </div>
          {/* end::Link */}
          <div>
            {statusCode === 404 ? (
              <Link to={'/'} className='btn btn btn-sm btn-light-primary mt-5'>
                Voltar ao inicio
              </Link>
            ) : (
              ''
            )}
          </div>
        </div>
      )}

      {/* end::Title */}
    </>
  )
}
